import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function CalibrationHistory() {
  return (
    <ScaffoldPage
      title="Calibration History"
      description="Track calibration changes over time with before/after comparisons."
      breadcrumbs={buildBreadcrumbs('/settings/calibration/history')}
      plannedFeatures={[
        'Chronological calibration change log',
        'Before/after dimension weight comparisons',
        'Rollback to previous calibration configurations',
        'Export calibration history for compliance',
      ]}
      relatedPages={[
        { label: 'Calibration Overview', href: '/settings/calibration/overview' },
        { label: 'Dimensions', href: '/settings/calibration/dimensions' },
        { label: 'Presets', href: '/settings/calibration/presets' },
      ]}
    />
  )
}
